
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class LogoMain extends Vue {
  @Prop({ default: false }) isShort!: boolean
  @Prop({ default: true }) clickable!: boolean
  @Prop({ default: '43px' }) widthLogo!: string
  @Prop({ default: '160px' }) widthLogoText!: string

  get path() {
    return '/'
  }
}
